/***************/
/**  IMPORTS  **/
/***************/
import React from "react";

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { 
         ParkBarContainer,
         MyCol,
         MyRow } from "../../styles/ParkBarStyles";

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/

const ParkBar = ({parks, height}) => {
    // console.log(parks);

    let dynamicStyle = {padding: "10px"};
    if(Array.isArray(parks)){
        height = height / (parks.length + 1);
    } else {
      const tokens = parks.split(" ");
      dynamicStyle = tokens.includes("Park")
            ? {}
            : {
                backgroundColor: "#dfdfdf"
              };
    }
    
    return (
    <React.Fragment>
      {Array.isArray(parks) ? (
        parks.map((park, index) => {
            const tokens = park.split(" ");
            dynamicStyle = tokens.includes("Park")
            ? {}
            : {
                backgroundColor: "#dfdfdf",
                padding: "15px"
              };

          return (
            <ParkBarContainer key={index} style={dynamicStyle}>
              <MyRow>
                <MyCol
                  style={{
                    height: height
                  }}>
                  {park}
                </MyCol>
              </MyRow>
            </ParkBarContainer>
          );
        })
      ) : (
        <ParkBarContainer style={dynamicStyle}>
            <MyRow>
                <MyCol style={{ 
                        height: height}}>
                    {parks}
                </MyCol>
            </MyRow>
        </ParkBarContainer>
      )}
    </React.Fragment>
  );
};

export default ParkBar;